export var env = {
  backendApiServer: "https://path-api-jqxrzbcnhq-nw.a.run.app"
//export var backendApiServer: "http://localhost:8080"
}
